<template>
  <b-form @submit.prevent="">
    <label for="municipio-search">Procurar município</label>
    <b-input-group>
      <base-input
        alternative
        type="text"
        id="municipio-search"
        v-model="term"
        placeholder="Nome do município"
        addon-left-icon="ni ni-zoom-split-in"
      >
      </base-input>
    </b-input-group>
  </b-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "InputSearchLocation",
  data() {
    return { term: "" };
  },
  watch: {
    term: function(val) {
      this.search({ term: val, in: this.municipios });
    }
  },
  computed: {
    ...mapGetters(["municipios"])
  },
  methods: {
    ...mapActions(["search"])
  },
  mounted() {
    document.getElementById('municipio-search').focus()
  }
};
</script>

<style>

.input-municipio {
  font-size: 1.2rem !important;
  color: #6f7789 !important;
  font-family: inherit;
}

</style>
